import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { NgForm } from '@angular/forms';
import { AppState } from '../../../store';
import { BaseForm, BaseFormInterface } from '../../../common/base/base-form.component';
import { SalesforceConnection } from '../../connection.models';
import { NotifyService } from '../../../common/services/notify.service';
import { selectConnectionsErrors } from '../../store/connections.selectors';

@Component({
  selector: 'connection-form-hubspot-oauth',
  template: `
    <xp-form-validation type="HubspotOauthConnection" [name]="formName">
      <form id="connectionFormHubspotOAuth" name="connectionFormHubspotOAuth" #form="ngForm" class="form">
        <div *ngIf="!connectionTypeButtonCreate">
          <p class="lead">{{ 'connection-form-hubspot-oauth.sign_in_text' | translate }}</p>
        </div>
        <div class="row" *ngIf="connectionTypeButtonCreate">
          <div class="col-md-6">
            <xp-form-group>
              <label for="name">{{ 'connections.form.labels.name' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="name"
                id="name"
                [(ngModel)]="connection.name"
                placeholder=""
              ></xp-input>
            </xp-form-group>
            <div class="form-group" *ngIf="connection.unique_id">
              <label for="unique_id">{{ 'connections.form.labels.unique_id' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="unique_id"
                id="unique_id"
                [(ngModel)]="connection.unique_id"
                [attr.readonly]="true"
                [readOnly]="true"
              ></xp-input>
            </div>
          </div>
        </div>
      </form>
    </xp-form-validation>
  `,
})
export class ConnectionFormHubspotOAuthComponent extends BaseForm implements BaseFormInterface {
  @Input() connection: Partial<SalesforceConnection> = {};
  @Input() connectionTypeButtonCreate: boolean;
  @Output() formValidationChange = new EventEmitter<boolean>();

  @ViewChild('form') form: NgForm;
  formName = 'connectionFormHubspotOAuth';
  successMessageText = 'connection.form.success_message';
  errors$ = this.store.select(selectConnectionsErrors);
  errorTexts = [];

  constructor(
    protected store: Store<AppState>,
    protected notify: NotifyService,
    protected translate: TranslateService,
  ) {
    super();
  }
}
